// extracted by mini-css-extract-plugin
export default {"activityContainer":"activityIndicator_activityContainer__uflFa","spin":"activityIndicator_spin__ennaZ"};